import React, { useState } from 'react';
import { t } from '../lib/i18n';
import DealCard from './DealCard';
import { ChevronRight, Crown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';

const SeeAll = ({ showAll, onClick }) => (
  <button onClick={onClick} className="flex items-center gap-1 text-sm font-semibold text-[#B3B3B3] hover:text-[#E50914] transition-colors" data-testid="see-all-btn">
    {showAll ? t('Voir moins') : t('Tout voir')}
    <ChevronRight size={16} className={`transition-transform ${showAll ? 'rotate-90' : ''}`} />
  </button>
);

const DealSection = ({ title, icon, deals, initialCount = 6, columns = 4, newIds, sponsor, shine = false }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleDeals = showAll ? deals : deals.slice(0, initialCount);

  return (
    <section className={title ? 'py-6' : 'pb-6'} data-testid="deal-section">
      {/* Section Header */}
      {title ? (
        <SectionHeading icon={icon} testId="section-title" shine={shine} right={deals.length > initialCount && <SeeAll showAll={showAll} onClick={() => setShowAll(!showAll)} />}>{t(title)}</SectionHeading>
      ) : deals.length > initialCount && (
        <div className="flex justify-end mb-5"><SeeAll showAll={showAll} onClick={() => setShowAll(!showAll)} /></div>
      )}

      {/* Cards Grid */}
      <div className={`grid grid-cols-2 gap-2 ${
        columns === 3 
          ? 'sm:grid-cols-2 md:grid-cols-3' 
          : 'sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
      }`}>
        {visibleDeals.map((deal) => (
          sponsor && deal.brand_id === sponsor.brand_id ? (
            <div key={deal.id} className="relative" data-testid="deal-card-sponsor-wrap">
              <span className="absolute top-3 start-3 z-20 px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider inline-flex items-center gap-1 shadow-lg" style={{ background: sponsor.color, color: sponsor.on }} data-testid={`deal-sponsor-badge-${deal.id}`}><Crown size={11} /> {t('Sponsor officiel')}</span>
              <DealCard deal={deal} isNew={!!newIds?.has(deal.id)} />
            </div>
          ) : <DealCard key={deal.id} deal={deal} isNew={!!newIds?.has(deal.id)} />
        ))}
      </div>

      {/* Show more button for mobile */}
      {deals.length > initialCount && !showAll && (
        <div className="flex justify-center mt-6">
          <button
            onClick={() => setShowAll(true)}
            className="px-6 py-2.5 rounded-sm border border-[#262626] text-sm font-semibold text-[#B3B3B3] hover:border-[#E50914] hover:text-[#E50914] hover:bg-[#E50914]/10 transition-all active:scale-95"
            data-testid="show-more-btn"
          >
            {t('Voir plus de catalogues')}
          </button>
        </div>
      )}
    </section>
  );
};

export default DealSection;
